module.exports = __webpack_public_path__ + "img/product-preview-9.db0c4e4.png";